import { ProLightFilter } from '@nexelem/icons/ProLightFilter';
import { noop } from 'lodash';
import { useEffect, useState } from 'react';
import { useFiltersContext } from '../../hooks';
import { CustomIconButton } from '../CustomIconButton';

interface FiltersIconProps {
  readonly disabled?: boolean;
  readonly onClick?: () => void;
}

export const FilterIcon = ({ disabled, onClick }: FiltersIconProps) => {
  const { filters } = useFiltersContext();

  const [withIndicator, setWithIndicator] = useState<boolean>(false);

  useEffect(() => {
    setWithIndicator(
      Object.values(filters || {}).some((filter) => {
        if (Array.isArray(filter.value)) {
          return !!filter.value.length;
        }
        if (typeof filter.value === 'object') {
          return Object.values(filter.value as object).some((value) => !!value);
        }

        return !!filter.value;
      }),
    );
  }, [filters]);

  return (
    <CustomIconButton
      disabled={disabled}
      Icon={ProLightFilter}
      withIndicator={withIndicator}
      onClick={onClick ?? noop}
    />
  );
};
